import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";

const MotorcyclePurchase = () => {
  return (
    <div className="about-page">
      <>
          <Helmet>
              <title>Pro Moto - skup motocykli</title>
              <meta
              name="description"
              content="PRO MOTO Chcesz sprzedać motocykl szybko, uczciwie i bez tuzina niepewnych oglądających? 
              W PRO MOTO załatwimy wszystko w pół godziny: od wyceny i oględzin, 
              po wypłatę gotówki i komplet dokumentów. Po prostu zostawiasz maszynę, wychodzisz z pieniędzmi."
              />
              <link rel="canonical" href="https://promotoserwis.pl/skup" />
          </Helmet>
      </>
      <section className="about-hero">
        <div className="about-hero__content">
          <motion.h1
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>Skup motocykli</motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}><strong>Gotówka od ręki!</strong></motion.p>
          <motion.p
            initial={{ opacity: 0, y: 90 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
              Chcesz sprzedać motocykl szybko, uczciwie i bez tuzina niepewnych oglądających? 
              W PRO MOTO załatwimy wszystko w pół godziny: od wyceny i oględzin, 
              po wypłatę gotówki i komplet dokumentów. Po prostu zostawiasz maszynę, wychodzisz z pieniędzmi.
          </motion.p>


          <button
            className="about-scroll-btn"
            onClick={() =>
              document.querySelector(".about-extra").scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <span className="arrow"></span>
          </button>
        </div>
      </section>


      <section className="about-extra">
        <div className="about-extra__container">

          <div className="about-block">
            <h2>Dlaczego warto sprzedać motocykl właśnie nam?</h2>
            <ul>
                <li><strong>Szybka, rynkowa wycena</strong> – opieramy się na realnych cenach transakcyjnych, a nie na „tablicowych” marzeniach.</li>
                <li><strong>Płatność natychmiastowa</strong> – gotówka do ręki lub przelew ekspresowy.</li>
                <li><strong>Minimum formalności</strong> – przygotowujemy umowę kupna-sprzedaży, pomagamy wypełnić PCC-3 i od ręki zdejmujemy Cię z OC.</li>
                <li><strong>Jedna wizyta – koniec tematu</strong> – bez dziesiątek telefonów, niekończących się negocjacji i pokazów próbnych.</li>
                <li><strong>Zaufanie potwierdzone opiniami</strong> – ponad 130 pozytywnych recenzji w Google, długoletnie doświadczenie w branży moto.</li>
            </ul>
          </div>
          <div className="about-block">
            <h2>Jak przebiega transakcja?</h2>
            <ol>
              <li><strong>Kontakt i wstępna wycena</strong> <br/>Zadzwoń, napisz lub wypełnij napisz mail. Podaj markę, model, rok i krótki opis stanu motocykla – my wracamy do Ciebie z widełkami cenowymi.</li>
              <li><strong>Spotkanie w warsztacie lub u Ciebie</strong> <br/>Najszybciej będzie, jeśli przyjedziesz do nas do: Mrowino ul. Dworcowa 12. Jeśli motocykl jest niesprawny – możemy go odebrać naszym busem.</li>
              <li><strong>Oględziny i ostateczna wycena</strong> <br/>Sprawdzamy numer VIN, przebieg, zużycie kluczowych podzespołów. W ciągu 10 minut otrzymujesz finalną ofertę.</li>
              <li><strong>Podpisanie umowy</strong> <br/>Wydruk umowy, kserokopie dokumentów, potwierdzenie wypłaty – wszystko dzieje się u nas w biurze.</li>
              <li><strong>Gotówka lub przelew ekspresowy</strong> <br/> Wybierasz formę płatności. Gotówkę wypłacamy od razu z kasy, przelew ekspresowy trafia na Twoje konto w kilka minut.</li>
              <li><strong>Zajmujemy się resztą</strong> <br/>Wyrejestrowanie pojazdu, zgłoszenie sprzedaży do ubezpieczyciela, ewentualne odbiory transportowe – masz to z głowy.</li>
            </ol>
          </div>

          <div className="about-block ">
            <h2>Jakie motocykle kupujemy?</h2>
            <ul>
                <li>Sportowe, turystyczne, naked, cross, enduro, chopper</li>
                <li>Quady i skutery powyżej 125 cm³.</li>
                <li>Motocykle po stłuczce lub z uszkodzeniami mechanicznymi (wycena adekwatna do stanu).</li>
            </ul>
          </div>

          <div className="about-block">
            <h2>NIE SKUPUJEMY CHIŃSKICH POJAZDÓW SPRZED 2020 ROKU.</h2>
          </div>
          <div className="about-block ">
            <h2>Co musisz przygotować?</h2>
            <ul>
                <li>Dowód rejestracyjny i kartę pojazdu (jeśli była wydana).</li>
                <li>Ważne OC lub potwierdzenie wygaśnięcia polisy.</li>
                <li>Dowód tożsamości właściciela (lub pełnomocnictwo, gdy sprzedajesz w imieniu firmy).</li>
                <li>Dodatkowy kluczyk, książka serwisowa i faktury – jeśli je posiadasz, podnoszą wartość motocykla</li>
            </ul>
          </div>

          <div className="about-block about-block--final">
            <h2>Najczęstsze pytania</h2>
            <ul>
                <p>
                    <strong>Czy mogę sprzedać motocykl z kredytem lub zastawem?</strong> <br/>
                    Nie. Nie skupujemy motocykli z obciążeniami.
                </p>
                <p>
                    <strong>Czy wycena jest bezpłatna?</strong> <br/>
                    Tak, zarówno telefoniczna, jak i na miejscu. Jeśli oferta Ci nie odpowiada, nic nie płacisz.
                </p>
                <p>
                    <strong>Jak długo trwa transakcja?</strong> <br/>
                    Średnio 30 minut od wjazdu do podpisania umowy. (po wcześniejszym umówieniu wizyty)
                </p>
                <p>
                    <strong>Czy kupujecie motocykle zimą?</strong> <br/>
                    Tak, działamy cały rok. Zimą ceny mogą się różnić, ale skup funkcjonuje bez przerwy.
                </p>
                
            </ul>
          </div>
          <div className="about-block about-block--final">
            <h2>Skontaktuj się z nami już teraz</h2>
            <ul>
                <p>
                    Zadzwoń pod <strong>+48 535 744 816</strong> lub WhatsApp – odpowiemy w ciągu 24h i zaproponujemy konkretny termin oględzin.
                </p>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};



export default MotorcyclePurchase;